import React, { Component } from "react";
//import auth from "../services/authService";
//
import { toast } from "react-toastify";
import Table from "./common/table";
import Like from "./common/like";
import auth from "../services/authService";
import Lock from "./common/lock";
import Moment from "react-moment";

import TextareaAutosize from "react-textarea-autosize";
import {
  LockDream_Mob,
  DreamAdmin,
  PostDream_,
  CustomerRate,
  PrivatePerson,
  PersonalStatus,
} from "../services/dreamNewService";
import { isBlockedShortCode } from "../utils/shortCodeStatus";
import { appendQuickReply } from "../utils/quickReplies";
import CopyableText from "./common/copyableText";
import { sclist } from "../sc.json";
const getShortCodeTextClass = (shortCode) =>
  shortCode ? `row${shortCode}color` : "";
//import { toast } from "react-toastify";
//import MessageCount from "./common/messageCount";

class DreamsTableShowMob extends Component {
  state = {
    modalIsOpen: false,
    errors: {},
    dream: [],
    replyMsg: "",
    MT_Englsih: "",
    personStatus: "",
    ReplyID: 0,
    disableSent: false,
    shortCodeFilter: "all",
    replyDrafts: {},
  };

  handelSelectCustomerRate = async (event, dream) => {
    //console.log(event.target.value);
    //console.log(dream);
    // const btn = { title: event.target.value, name:"8"  };
    //  this.props.onItemSelect(btn,"8");
    dream.customerRate = event.target.value;
    this.props.OnAction(dream);
    const stat = await CustomerRate(dream);
  };

  handelSelectPrivate = async (dream) => {
    dream.isprivate = !dream.isprivate;

    this.props.OnAction(dream);
    const stat = await PrivatePerson(dream);
  };

  handleChangeInput = (dream) => ({ currentTarget: input }) => {
    let name = input.name;

    if (dream.isSent) {
      if (dream["MsgRegFroSend"] === 1) {
        dream["MsgRegFroSend"] = 2;
        name = "ReplyMsg2";
      } else if (dream["MsgRegFroSend"] === 2) {
        dream["MsgRegFroSend"] = 3;
        name = "ReplyMsg3";
      } else {
        dream["MsgRegFroSend"] = 4;
        name = "ReplyMsg4";
      }
      dream["isSent"] = false;
    }

    dream[name] = input.value;
    this.setState((state) => ({
      dream: dream,
      replyDrafts: {
        ...state.replyDrafts,
        [this.getReplyDraftKey(dream, name)]: input.value,
      },
    }));

    if (this.props.onChangeText) {
      this.props.onChangeText(dream, name, input.value);
    }
  };
  handleChangeInput1 = (dream) => ({ currentTarget: input }) => {
    dream[input.name] = input.value;
    this.setState({ dream: dream });

    if (this.props.onChangeText) {
      this.props.onChangeText(dream, input.name, input.value);
    }
  };

  handleChangeInputBlur = (dream) => ({ currentTarget: input }) => {
    const name =
      input.name === "MT_Reply_Msg" ? this.getReplyInputName(dream) : input.name;
    dream[name] = input.value;
    this.setState((state) => ({
      dream: dream,
      replyDrafts: {
        ...state.replyDrafts,
        [this.getReplyDraftKey(dream, name)]: input.value,
      },
    }));

    if (this.props.onChangeText) {
      this.props.onChangeText(dream, name, input.value);
    }
  };

  getReplyInputName = (dream) => {
    if (dream.MsgRegFroSend === 2) return "ReplyMsg2";
    if (dream.MsgRegFroSend === 3) return "ReplyMsg3";
    if (dream.MsgRegFroSend === 4) return "ReplyMsg4";
    return "MT_Reply_Msg";
  };

  getReplyDraftKey = (dream, name = this.getReplyInputName(dream)) =>
    `${dream.ReplyID}:${name}`;

  getReplyInputValue = (dream) => {
    const name = this.getReplyInputName(dream);
    const draftKey = this.getReplyDraftKey(dream, name);

    if (this.state.replyDrafts.hasOwnProperty(draftKey)) {
      return this.state.replyDrafts[draftKey];
    }

    if (dream[name] !== undefined && dream[name] !== null) {
      return dream[name];
    }

    return this.getDefaultMessage(dream) || "";
  };

  getReplyInputLength = (dream) => {
    return this.getReplyInputValue(dream).length;
  };

  handleUseQuickContactReply = (dream) => {
    const name = this.getReplyInputName(dream);
    const nextMessage = appendQuickReply(this.getReplyInputValue(dream));
    dream[name] = nextMessage;
    this.setState((state) => ({
      dream,
      replyDrafts: {
        ...state.replyDrafts,
        [this.getReplyDraftKey(dream, name)]: nextMessage,
      },
    }));

    if (this.props.onChangeText) {
      this.props.onChangeText(dream, name, nextMessage);
    }
  };

  handleShortCodeFilterChange = (event) => {
    this.setState({ shortCodeFilter: event.target.value });
  };

  getFilteredDreams = () => {
    const { dreamsNONReplyMob } = this.props;
    const { shortCodeFilter } = this.state;

    if (!dreamsNONReplyMob) return [];

    if (shortCodeFilter === "old") {
      return dreamsNONReplyMob.filter((dream) =>
        isBlockedShortCode(dream.MOShortCode)
      );
    }

    if (shortCodeFilter === "ahlamkom") {
      return dreamsNONReplyMob.filter(
        (dream) => !isBlockedShortCode(dream.MOShortCode)
      );
    }

    return dreamsNONReplyMob;
  };

  HandleSendMsImmidatly = async () => {
    try {
      let dream = this.state.dream;
      const email = await auth.getCurrentUser();
      if (this.props.pcode === 999) {
        dream["isRedyToSent"] = true;

        dream["CheckerName"] = "adib@salmustasharak.com";
        dream["ReplyUserName"] = email;
        dream["Userlock"] = email;
        dream["userlockDate"] = new Date();
        dream["IsReply"] = true;
        //dream["MufasserMsg"] = dream["MT_Reply_Msg"];
      } else {
        dream["isRedyToSent"] = false;
        dream["CheckerName"] = "adib@salmustasharak.com";
        dream["ReplyUserName"] = email;
        dream["Userlock"] = email;
        dream["userlockDate"] = new Date();
        dream["IsReply"] = true;
        //dream["MufasserMsg"] = dream["MT_Reply_Msg"];
      }
      this.props.OnAction(dream);
      const stat = await PostDream_(dream);
      toast.success("تم الارسال بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };
  HandleSendMsg = async () => {
    try {
      let dream = this.state.dream;
      const email = await auth.getCurrentUser();
      dream["MT_Date"] = new Date();

      dream["ReplyDate"] = new Date();

      if (this.props.pcode === 999 && dream["IsReply"] === true) {
        dream["isRedyToSent"] = true;
      } else {
        dream["isRedyToSent"] = false;
        dream["CheckerName"] = "adib@salmustasharak.com";
        dream["ReplyUserName"] = email;
        dream["Userlock"] = email;
        dream["userlockDate"] = new Date();
        dream["IsReply"] = true;
        //dream["MufasserMsg"] = dream["MT_Reply_Msg"];
      }

      dream["MsgRegFroSend"] = 1;

      dream["MT_NoOfMsg"] = dream["MT_Reply_Msg"].length;
      dream["IsPending"] = true;

      //console.log(dream);

      this.props.OnAction(dream);
      const stat = await PostDream_(dream);
      //console.log(stat);
      toast.success("تم الارسال بنجاح", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  handleToAdmin = async (dream, status) => {
    try {
      if (status === "حجز") {
        if (dream["islockAdmin"]) {
          dream["islockAdmin"] = false;
          dream.userlockDate = null;
          dream.Userlock = "";
          dream.ReplyUserName = "";

          dream.islock = false;
          this.props.OnAction(dream);
          const stat = await DreamAdmin(dream);
          return;
        } else {
          dream["islockAdmin"] = true;
          dream.userlockDate = new Date();
          dream.Userlock = "adib@salmustasharak.com";
          dream.ReplyUserName = "adib@salmustasharak.com";

          dream.islock = true;
          this.props.OnAction(dream);
          const stat = await DreamAdmin(dream);
          return;
        }
      } else if (status === "فك للشيخ أديب") {
        dream["MT_Arabic"] = dream.ReplyUserName;
        dream["ReplyUserName"] = "adib@salmustasharak.com";
        dream["islockAdmin"] = true;
        dream.userlockDate = new Date();
        dream.Userlock = "adib@salmustasharak.com";
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "حذف أدمن") {
        dream["MT_Date"] = new Date();
        dream["ReplyDate"] = new Date();
        dream["isdelete"] = true;

        dream["ReplyUserName"] = this.props.user;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "الغاء الحذف") {
        dream["MT_Date"] = null;
        dream["ReplyDate"] = null;
        dream["isdelete"] = false;

        dream["ReplyUserName"] = "";
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else if (status === "الغاء الارسال") {
        const currentDate = new Date();
        currentDate.setSeconds(currentDate.getSeconds() - 50);
        if (currentDate > dream.MT_Date) {
          toast.error("لا يمكن ايقاف الرسالة", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return;
        }
        dream["isRedyToSent"] = true;
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
        //"فك الحلم"
      } else if (status === "فك الحلم") {
        dream["IsReply"] = false;

        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
        return;
      } else {
        dream["MT_Date"] = new Date();
        dream["ReplyDate"] = new Date();
        dream["isRedyToSent"] = false;
        dream["MsgRegFroSend"] = 1;
        dream["MT_Arabic"] = status;
        dream["MT_NoOfMsg"] = dream["MT_Arabic"].length;
        dream["IsPending"] = true;
        dream["IsReply"] = true;
        dream["ReplyUserName"] = "adib@salmustasharak.com";
        dream["userlockDate"] = new Date();
        dream["Userlock"] = this.props.user.replace("@salmustasharak.com", "");
        this.props.OnAction(dream);
        const stat = await DreamAdmin(dream);
      }
    } catch (ex) {
      toast.error("حدث خطأ ", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };
  handleChangeInputFocus = (dream) => ({ target: input }) => {
    dream[input.name] = input.value;
    this.setState({ dream: dream });
  };
  handlePS = async () => {
    if (this.state.dream) {
      const stat = await PersonalStatus(this.state.dream);
    } else {
      toast.error("لم تغير الحالة", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  };

  getDefaultMessage = (dream) => {
    let defaultMessage = dream.MT_Reply_Msg || "";
    const shortCode = String(dream.MOShortCode); // Ensure MOShortCode is a string



    if (["4022", "2337", "6877", "4142"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += `\n\n تنويه مهم: هذا الرقم للتفسير ${shortCode} أصبح قديماً، وتم استبداله برقم 7994 لتفسير الأحلام الجديدة، مع إضافة خدمة مميزة جداً وهي خدمة جديدة سريعة جداً عبر وتساب 0507354835 يصل التفسير الكتابي خلال أقل من ساعة، برسوم أوفر 25% مقارنة بالأس أم أس.`;
    } else if (["4024", "6055"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += `\n\n تنويه مهم: هذا الرقم للتفسير ${shortCode} أصبح قديماً، وتم استبداله برقم 7994 لتفسير الأحلام الجديدة، مع إضافة خدمة مميزة جداً وهي خدمة جديدة سريعة جداً عبر وتساب 0507354835 يصل التفسير الكتابي خلال أقل من ساعة، برسوم أوفر 25% مقارنة بالأس أم أس.`;
    } else if (["3900", "2304", "3772"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += "";
    }



    return defaultMessage;
  };

  render() {
    let columns;
    const pStyle = {
      fontSize: "18pt",
      direction: "rtl",
      color: "Red",
    };
    const pStyle2 = {
      fontSize: "18pt",
      direction: "rtl",
      color: "DarkRed",
    };
    const wStyle = {
      wordWrap: "break-word",
      fontWeight: "bold",
      fontSize: "25pt",
    };
    columns = [
      {
        path: "MOShortCode",
        label: "اجراءات",
        content: (dream) => (
          <div className="row flex-nowrap">
            <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right  flex-nowrap">
              {this.props.pcode === 999 && (
                <button
                  type="button"
                  className="btn btn-warning   btn-block"
                  onClick={() => this.handleToAdmin(dream, "العاجل")}
                >
                  العاجل{" "}
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary   btn-block"
                onClick={() => this.handleToAdmin(dream, "مكرر")}
              >
                مكرر{" "}
              </button>
              <br></br>
              {this.props.pcode === 999 && (
                <div>
                  {dream.IsReply && !dream.isRedyToSent && (
                    <button
                      type="button"
                      className="btn btn-warning   btn-block"
                      onClick={() => this.handleToAdmin(dream, "فك الحلم")}
                    >
                      فك الحلم{" "}
                    </button>
                  )}
                  {!dream.isdelete && !dream.isSent && (
                    <button
                      type="button"
                      className="btn btn-danger   btn-block"
                      onClick={() => this.handleToAdmin(dream, "حذف أدمن")}
                    >
                      {" "}
                      حذف أدمن{" "}
                    </button>
                  )}
                  {dream.isdelete && (
                    <button
                      type="button"
                      className="btn btn-danger   btn-block"
                      onClick={() => this.handleToAdmin(dream, "الغاء الحذف")}
                    >
                      الغاء الحذف
                    </button>
                  )}
                  {!dream.isSent && dream.isRedyToSent && (
                    <button
                      type="button"
                      className="btn btn-primary   btn-block"
                      onClick={() => this.handleToAdmin(dream, "الغاء الارسال")}
                    >
                      الغاء الارسال{" "}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        ),
      },
      {
        path: "MO_Message",
        label: "الرسالة",
        content: (dream) => (
          <div className="row flex-nowrap">
            <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right  flex-nowrap">
              <div
                className={
                  dream.MOShortCode === 7570 || dream.MOShortCode === 4060
                    ? "bg-warning text-dark"
                    : "bg-light text-dark"
                }
              >
                {this.props.pcode === 999 ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-danger   btn-block"
                      onClick={() => this.handlePS()}
                    >
                      {" "}
                      حفظ الحالة{" "}
                    </button>
                    <TextareaAutosize
                      minRows={1}
                      className="form-control"
                      rows={2}
                      style={pStyle2}
                      id={"PersonStatus" + dream.ReplyID}
                      name="PersonStatus"
                      onChange={this.handleChangeInput1(dream)}
                      onFocus={this.handleChangeInputFocus(dream)}
                      onBlur={this.handleChangeInputBlur(dream)}
                      defaultValue={dream.PersonStatus}
                      placeholder="اكتب هنا الحالة "
                    //  ref={(input) => { this.nameInput = input; }}
                    />
                  </div>
                ) : (
                  ""
                )}

                <h4 className="text-danger">{dream.RefNo}</h4>

                {dream.IsNew === false ? (
                  ""
                ) : (
                  <i className="fa fa fa-star fa-4x text-warning" />
                )}

                <div
                  className={`text-right ${getShortCodeTextClass(
                    dream.MOShortCode
                  )}`}
                >
                  <div style={wStyle} dangerouslySetInnerHTML={{
                    __html: dream.ReplyMsg4
                  }}></div>
                  <br />
                  <h4 style={wStyle}>
                    {" "}
                    {dream.MT_Arabic
                      ? dream.length < 15
                        ? dream.MT_Arabic
                        : ""
                      : ""}
                  </h4>
                  {this.state.dream["ReplyID"] === dream.ReplyID ? (
                    <div className="form-group">
                      {this.props.pcode === 999 ? (
                        <div className="container">
                          <div className="row">
                            <div className="col align-self-start">

                              <br></br>
                              <button
                                onClick={() =>
                                  this.HandleSendMsImmidatly(dream)
                                }
                                className="btn text-right btn-success btn-sm"
                              >
                                ارسال مباشر
                              </button>
                            </div>
                            <div className="col align-self-center text-center">
                              <button
                                type="button"
                                onClick={() =>
                                  this.handleUseQuickContactReply(dream)
                                }
                                className="btn text-right btn-info btn-sm"
                                title="إضافة نص التواصل في آخر خانة الرد"
                              >
                                <i
                                  className="fa fa-commenting-o"
                                  aria-hidden="true"
                                />{" "}
                                نص التواصل
                              </button>
                            </div>
                            <div className="col align-self-end">
                              <button
                                onClick={() => this.HandleSendMsg(dream)}
                                className="btn text-right btn-success btn-sm"
                              >
                                ارسال
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <button
                          onClick={() => this.HandleSendMsg(dream)}
                          className="btn text-right btn-success btn-sm"
                        >
                          ارسال
                        </button>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  <hr></hr>
                  <h4> {dream.MufasserMsg}</h4>
                  <hr></hr>
                  <br></br>
                  <h4> {dream.ReplyMsg2}</h4>
                  <hr></hr>
                  <br></br>
                  <h4> {dream.ReplyMsg3}</h4>

                  <br></br>
                  <TextareaAutosize
                    minRows={4}
                    className="form-control"
                    style={pStyle}
                    rows={4}
                    id={"MT_Reply_Msg" + dream.ReplyID}
                    name={this.getReplyInputName(dream)}
                    onChange={this.handleChangeInput(dream)}
                    onFocus={this.handleChangeInputFocus(dream)}
                    onBlur={this.handleChangeInputBlur(dream)}
                    value={this.getReplyInputValue(dream)}
                    placeholder="اكتب التفسير هنا"
                  //ref={this.inputReply}
                  />
                  {this.state.dream["ReplyID"] === dream.ReplyID ? (
                    <div className="form-group">
                      <span className="label label-primary">
                        عدد الحروف{" "}
                        {this.getReplyInputLength(dream)}{" "}
                        - عدد الرسائل{" "}
                        {this.getReplyInputLength(dream) &&
                          this.getReplyInputLength(dream) < 71
                          ? 1
                          : Math.ceil(
                            this.getReplyInputLength(dream) / 63
                          )}
                      </span>
                      <br />
                      {this.props.pcode === 999 ? (
                        <div className="container">
                          <div className="row">
                            <div className="col align-self-start">
                              <button
                                onClick={() =>
                                  this.HandleSendMsImmidatly(dream)
                                }
                                className="btn text-right btn-success btn-sm"
                              >
                                ارسال مباشر
                              </button>
                            </div>
                            <div className="col align-self-center text-center">
                              <button
                                type="button"
                                onClick={() =>
                                  this.handleUseQuickContactReply(dream)
                                }
                                className="btn text-right btn-info btn-sm"
                                title="إضافة نص التواصل في آخر خانة الرد"
                              >
                                <i
                                  className="fa fa-commenting-o"
                                  aria-hidden="true"
                                />{" "}
                                نص التواصل
                              </button>
                            </div>
                            <div className="col align-self-end">
                              <button
                                onClick={() => this.HandleSendMsg(dream)}
                                className="btn text-right btn-success btn-sm"
                              >
                                ارسال
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <button
                          onClick={() => this.HandleSendMsg(dream)}
                          className="btn text-right btn-success btn-sm"
                        >
                          ارسال
                        </button>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  <br />
                </div>
              </div>
            </div>
          </div>
        ),
      },
      {
        path: "MT_Mobil",
        label: "المعلومات",
        content: (dream) => (
          <div className="row flex-nowrap">
            <div className="col-12 col-lg-12  col-md-12 col-sm-12 col-xs-12 text-right  flex-nowrap">
              {dream.customerRate === 2222 ? (
                <img
                  src={require("./img/s1.jpg")}
                  alt="Fjords"
                  style={{ width: "70px", height: "70px", cursor: "pointer" }}
                />
              ) : (
                ""
              )}
              {this.props.pcode === 999 ? (
                <i
                  onClick={() => this.props.onOpenModel(dream)}
                  style={{ cursor: "pointer" }}
                  className="fa fa-database fa-lg"
                  aria-hidden="true"
                />
              ) : (
                ""
              )}

              {this.props.pcode > 10 ? (
                <div
                  className={
                    1000 === dream.customerRate
                      ? "bg-1"
                      : 100 === dream.customerRate || 0 === dream.customerRate
                        ? ""
                        : 500 === dream.customerRate
                          ? "bg-2"
                          : 1 === dream.customerRate
                            ? "bg-3"
                            : 9 === dream.customerRate
                              ? "bg-4"
                              : 2 === dream.customerRate
                                ? "bg-5"
                                : 3 === dream.customerRate
                                  ? "bg-6"
                                  : ""
                  }
                >
                  {this.props.pcode === 999 ? (
                    <h4>
                      <select
                        className="selectpicker"
                        value={dream.customerRate}
                        onChange={(e) =>
                          this.handelSelectCustomerRate(e, dream)
                        }
                      >
                        <option
                          value="200"
                          key="200"
                          className={
                            200 === dream.customerRate ||
                              0 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          عادي
                        </option>

                        <option
                          value="1000"
                          key="1000"
                          className={
                            1000 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          مهم جداً
                        </option>
                        <option
                          value="500"
                          key="500"
                          className={
                            500 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          أحلامه كثيرة جداً
                        </option>

                        <option
                          value="4"
                          key="4"
                          className={
                            4 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          ثرثرة وسيئ
                        </option>

                        <option
                          value="9"
                          key="9"
                          className={
                            9 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          عجول+عاجل
                        </option>
                        <option
                          value="2222"
                          key="2222"
                          className={
                            2222 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          خدمة التفسير سريع
                        </option>
                        <option
                          value="1"
                          key="1"
                          className={
                            1 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          عجول جداً
                        </option>
                        <option
                          value="2"
                          key="2"
                          className={
                            2 === dream.customerRate
                              ? "list-group-item active"
                              : "list-group-item"
                          }
                        >
                          للحذف الفوري
                        </option>


                      </select>
                    </h4>
                  ) : (
                    ""
                  )}{" "}
                  &nbsp;&nbsp;{" "}
                  <div
                    className={`text-right ${getShortCodeTextClass(
                      dream.MOShortCode
                    )}`}
                  >
                    <button
                      type="button"
                      className="btn btn-primary   btn-block"
                      onClick={() => this.props.onUnLockAll(dream.MT_Mobil)}
                    >
                      عودة{" "}
                    </button>
                    <br></br>
                    {this.props.pcode === 999 ? (
                      <div>
                        <TextareaAutosize
                          minRows={3}
                          className="form-control"
                          rows={3}
                          style={pStyle}
                          id={"PersonStatus" + dream.ReplyID}
                          name="PersonStatus"
                          onChange={this.handleChangeInput1(dream)}
                          onFocus={this.handleChangeInputFocus(dream)}
                          onBlur={this.handleChangeInputBlur(dream)}
                          defaultValue={dream.PersonStatus}
                          placeholder="اكتب هنا الحالة "
                        //  ref={(input) => { this.nameInput = input; }}
                        />
                      </div>
                    ) : (
                      dream.PersonStatus
                    )}
                    {this.props.pcode === 999 ? (
                      <h4>
                        {" "}
                        {dream.MOShortCode}{" "}
                        {isBlockedShortCode(dream.MOShortCode) ? "❌" : "✅"}{" "}
                        &nbsp;&nbsp;{" "}
                        {this.props.pcode === 999 ? (
                          <CopyableText value={dream.MT_Mobil} />
                        ) : (
                          "+971*****" + dream.MT_Mobil.substring(9)
                        )}
                      </h4>
                    ) : (
                      ""
                    )}
                    <button
                      type="button"
                      className="btn    btn-block "
                      onClick={() => this.props.onGetAll(dream.MT_Mobil)}
                    >
                      {sclist.map((shortCode) => (
                        <React.Fragment key={shortCode.sc}>
                          <span className={`badge badge-${shortCode.sc}`}>
                            <h4>
                              {
                                this.props.orginalDreams.filter(
                                  (x) =>
                                    x.MT_Mobil === dream.MT_Mobil &&
                                    x.MOShortCode === shortCode.sc
                                ).length
                              }
                            </h4>
                          </span>{" "}
                        </React.Fragment>
                      ))}
                    </button>
                    <br />
                    <h4>
                      <Moment
                        parse="YYYY-MM-DD HH:mm"
                        format="YYYY-MM-DD hh:mm A"
                        className="text-primary"
                      >
                        {dream.MO_Date}
                      </Moment>
                    </h4>

                    <br />
                    {this.props.pcode === 999 && (
                      <div>
                        <h4>
                          <Like
                            liked={dream.isprivate}
                            onClick={() => this.handelSelectPrivate(dream)}
                          />{" "}
                          &nbsp;&nbsp;{" "}
                          <Lock
                            locked={dream.islockAdmin}
                            onClick={() => this.handleToAdmin(dream, "حجز")}
                          />
                        </h4>

                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      },
    ];

    const { onSort, sortColumn } = this.props;
    const filteredDreams = this.getFilteredDreams();

    return (
      <React.Fragment>
        <div className="filter-row">
          <div className="filter-label">فلترة الشورت كود</div>
          <select
            className="selectpicker filter-select"
            value={this.state.shortCodeFilter}
            onChange={this.handleShortCodeFilterChange}
          >
            <option value="all">الكل</option>
            <option value="old">شورت كود قديم</option>
            <option value="ahlamkom">شورت كود أحلامكم</option>
          </select>
        </div>
        <Table
          columns={columns}
          data={filteredDreams}
          sortColumn={sortColumn}
          onSort={onSort}
        />
      </React.Fragment>
    );
  }
}

export default DreamsTableShowMob;



// WEBPACK FOOTER //
// ./src/components/dreamsTableShowMob.jsx